<!-- loader overlay -->
<div id="part-loader" class="fullLoader" *ngIf="loading$ | async">
  <div class="loader-content">
    <img src="assets/img/feather-loader.svg" class="loader" />
  </div>
</div>
